export const isWordpressExamWithInstance = (examCode) => {
    return [
        'wce',
        'wca',
        'wws',
        'wes'
    ].indexOf(examCode) !== -1
}